import * as Yup from "yup";

export const AdminSchema = Yup.object().shape({
  property_code: Yup.number()
    .required("Šifra nekretnine je obavezna")
    .typeError("Šifra nekretnine mora biti broj"),
  type: Yup.string().required("Tip nekretnine je obavezan"),
  property_sub_type: Yup.string().required("Vrsta nekretnine je obavezna"),
  city: Yup.string()
    .required("Mesto je obavezno")
    .notOneOf(["Izaberite mesto", ""], "Mesto je obavezno"),
  area: Yup.string()
    .required("Deo grada je obavezan")
    .notOneOf(
      ["Izaberite Lokaciju", "Prvo Izaberite Mesto", ""],
      "Deo grada je obavezan"
    ),
  property_size: Yup.number()
    .required("Kvadratura je obavezna")
    .typeError("Kvadratura mora biti broj"),
  price: Yup.number()
    .required("Cena je obavezna")
    .typeError("Cena mora biti broj"),
  rooms: Yup.string().when("type", {
    is: (type) => type === "top_search_cat_menu_apartments",
    then: Yup.string()
      .required("Sobnost je obavezna za stanove")
      .notOneOf(["Izaberite sobnost", ""], "Sobnost je obavezna za stanove"),
  }),
});
